import styled from "styled-components";

import { colourHierarchy } from "./StyledHelper";

export const H2 = styled.h2`
    color: ${props => colourHierarchy(props)};
    font-family: vag-rounded-light, Helvetica, Arial, sans-serif;
    font-size: 1.71em;
    font-style: normal;
    margin: ${props => (props.margin ? props.margin : "1em 0 0.25em")};
    padding: ${props => (props.padding ? props.padding : "0")};
    text-align: ${props => props.textAlign || "initial"};
`;
